module.exports = __webpack_public_path__ + "img/streak100.b72bfad7.png";